{
	"name": "merch",
	"version": "1.00.601",
	"author": "Calaosoft",
	"homepage": "https://calaosoft.fr/",
	"private": true,
	"description": "MerchApp",
	"scripts": {
		"version:update:win": "cd ../../tools/cli && npm run version:update:win -- merch",
		"publish:win": "cd ../../../_scripts && npm run publish",
		"deploy:ws": "cd ../../tools/workspace-updater && npm run start -- --workdir=../../apps/merch/couchdb"
	},
	"devDependencies": {
		"@capacitor-community/sqlite": "../../node_modules/@capacitor-community/sqlite",
		"@capacitor-mlkit/barcode-scanning": "../../node_modules/@capacitor-mlkit/barcode-scanning",
		"@capacitor/android": "../../node_modules/@capacitor/android",
		"@capacitor/app": "../../node_modules/@capacitor/app",
		"@capacitor/camera": "../../node_modules/@capacitor/camera",
		"@capacitor/cli": "../../node_modules/@capacitor/cli",
		"@capacitor/clipboard": "../../node_modules/@capacitor/clipboard",
		"@capacitor/core": "../../node_modules/@capacitor/core",
		"@capacitor/device": "../../node_modules/@capacitor/device",
		"@capacitor/filesystem": "../../node_modules/@capacitor/filesystem",
		"@capacitor/haptics": "../../node_modules/@capacitor/haptics",
		"@capacitor/keyboard": "../../node_modules/@capacitor/keyboard",
		"@capacitor/splash-screen": "../../node_modules/@capacitor/splash-screen",
		"@capacitor/status-bar": "../../node_modules/@capacitor/status-bar",
		"@onesignal/capacitor-plugin": "../../node_modules/@onesignal/capacitor-plugin",
		"capacitor-blob-writer": "../../node_modules/capacitor-blob-writer",
		"capacitor-community-device": "../../node_modules/capacitor-community-device",
		"capacitor-plugin-cipherlab": "../../node_modules/capacitor-plugin-cipherlab",
		"capacitor-sqlite-evmax-build-free": "../../node_modules/capacitor-sqlite-evmax-build-free",
		"cordova-plugin-androidx-adapter": "../../node_modules/cordova-plugin-androidx-adapter",
		"cordova-plugin-battery-status": "../../node_modules/cordova-plugin-battery-status",
		"cordova-plugin-file": "../../node_modules/cordova-plugin-file",
		"cordova-plugin-file-opener2": "../../node_modules/cordova-plugin-file-opener2",
		"cordova-plugin-file-transfer": "../../node_modules/cordova-plugin-file-transfer",
		"cordova-plugin-fingerprint-aio": "../../node_modules/cordova-plugin-fingerprint-aio",
		"cordova-plugin-network-information": "../../node_modules/cordova-plugin-network-information",
		"cordova-plugin-statusbar": "../../node_modules/cordova-plugin-statusbar",
		"cordova-plugin-vibration": "../../node_modules/cordova-plugin-vibration",
		"cordova-plugin-x-socialsharing": "../../node_modules/cordova-plugin-x-socialsharing",
		"cordova-plugin-zip": "../../node_modules/cordova-plugin-zip",
		"es6-promise-plugin": "../../node_modules/es6-promise-plugin"
	},
	"engines": {
		"node": ">=22.12.0"
	}
}